import { render, staticRenderFns } from "./PartTagContainer.vue?vue&type=template&id=fe28c1f0&"
import script from "./PartTagContainer.vue?vue&type=script&lang=js&"
export * from "./PartTagContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe28c1f0')) {
      api.createRecord('fe28c1f0', component.options)
    } else {
      api.reload('fe28c1f0', component.options)
    }
    module.hot.accept("./PartTagContainer.vue?vue&type=template&id=fe28c1f0&", function () {
      api.rerender('fe28c1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/PartTagContainer.vue"
export default component.exports